/**
 * Delegate event listener helper function
 * @param {String} event - The element to listen to
 * @param {String} selector - The selector for the element(s) to bind the event to
 * @param {Function} callback - The event handler function
 * @param {HTMLElement} [parent] - The context element
 *
 * @example
 * DelegateListener('click', '.foo', event => this.innerHTML = `clicked .foo` ) });
 */

const DelegateListener = (eventName, selector, callback, parent = document) => {
  parent.addEventListener(eventName, event => {
    let found = false;
    let element = event.target;
    while (element && !(found = element.matches(selector) ? element : false)) {
      element = element.parentElement;
    }
    if (found) {
      event.delegateTarget = element;
      callback.call(element, event);
    }
  });
};

export default DelegateListener;
